import React from 'react';
import {map} from 'lodash';
import {useSelector} from 'react-redux';

import {EducatorStore} from 'src/types/store';

import ColleagueInformationCard from './colleague-information-card';

interface Props {
  openReportEducatorModal?: () => void;
}

const Colleagues = ({openReportEducatorModal}: Props) => {
  const colleagues = useSelector((state: EducatorStore) => state.colleagues);

  return (
    <div className="account-settings-form">
      <section className="colleagues-section">
        <div className="colleagues-header">
          <h3 className="colleagues-title">Educators at My School</h3>
          <p className="colleagues-subtitle">
            If any of these educators are not currently employed at your school, please report them
            using the &quot;Report User&quot; button.
          </p>
        </div>
        {map(colleagues, (colleague) => (
          <ColleagueInformationCard
            {...colleague}
            key={colleague._id}
            {...{openReportEducatorModal}}
          />
        ))}
      </section>
    </div>
  );
};

export default Colleagues;
